import { STATE_LOCATION_NAME } from "common/constants";

export const getLabelInLocation = (label?: string, location?: string | null | undefined) => {
  if (!label) return "";
  return `${label}${
    location ? ` in ${location === "Delaware" ? STATE_LOCATION_NAME : location}` : ""
  }`;
};
